import { Box, List, ListItem, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import LocaleKeys from '../../../../locales/keys';
import TvPremiumDark from '../../../../images/tvPremiumDark.svg';
import TvPremiumLight from '../../../../images/tvPremiumLight.svg';
import TvAccessLight from '../../../../images/tvAccessLight.svg';
import TvAccessDark from '../../../../images/tvAccessLight.svg';
import TvProDark from '../../../../images/tvProDark.svg';
import TvProLight from '../../../../images/tvProLight.svg';

const useStyles = makeStyles((theme) => ({
  headerLabel: {
    fontFamily: 'Formula1-Bold',
    fontWeight: 700,
    fontSize: '18px',
    [theme.breakpoints.between('xs', 'md')]: {
      lineHeight: 1.43,
    },
  },
  priceDetails: {
    paddingLeft: '36px',
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(2),
      paddingLeft: '0',
    },
  },
  listItem: {
    fontSize: '14px',
    listStyleType: 'square',
    display: 'list-item',
  },
  planHeaderContainer: {
    flexWrap: 'wrap',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  productImage: {
    height: '16px',
    [theme.breakpoints.down('md')]: {
      width: '87%',
    },
  },
  productImageContainer: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      alignSelf: 'start',
    },
  },
}));

const RadioButtonLabel = ({ item, selectedEligiblePlanId }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const getImageBasedOnEntitlement = (entitlement) => {
    const entitlementImageConfig = {
      premium: () => ({
        light: TvPremiumLight,
        dark: TvPremiumDark,
      }),
      pro: () => ({
        light: TvProLight,
        dark: TvProDark,
      }),
      access: () => ({
        light: TvAccessLight,
        dark: TvAccessDark,
      }),
    };
    return entitlementImageConfig[entitlement]();
  };
  return (
    <Box
      width="100%"
      display="flex"
      flexDirection="column"
      paddingLeft={2}
      gridRowGap={16}
    >
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        className={classes.planHeaderContainer}
        gridRowGap={16}
      >
        <Typography className={classes.productImageContainer}>
          <img
            style={{ height: '16px' }}
            className={classes.productImage}
            src={
              item.Id === selectedEligiblePlanId
                ? getImageBasedOnEntitlement(item?.entitlement.toLowerCase())
                    .light
                : getImageBasedOnEntitlement(item?.entitlement.toLowerCase())
                    .dark
            }
            alt={item?.ProductProperties?.Baseproduct || item?.entitlement}
          />
        </Typography>
        <Box
          display="flex"
          flexDirection="row"
          className={classes.priceDetails}
        >
          <Typography
            className={classes.headerLabel}
            style={{ paddingRight: '4px' }}
          >
            {`${item.CurrencyProperties.Symbol}${item.Amount} `}
          </Typography>
          <Box display="flex">
            <Typography
              style={{
                fontSize: '14px',
                alignSelf: 'end',
                paddingRight: '2px',
              }}
            >{`/`}</Typography>
            <Typography
              style={{
                fontSize: '14px',
                alignSelf: 'end',
                paddingRight: '2px',
              }}
            >
              {`${
                item.BillingCycle === 'Annually'
                  ? t(LocaleKeys.subscriptionInfo.subscriptions.year)
                  : t(LocaleKeys.subscriptionInfo.subscriptions.month)
              }`}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box style={{ paddingLeft: '8px' }}>
        <List style={{ padding: '12px 20px' }}>
          {!!item?.enabledFeatureItems?.length &&
            item?.enabledFeatureItems.map((item) => (
              <ListItem
                className={classes.listItem}
                style={{ padding: '4px 0' }}
                key={item}
              >
                {item}
              </ListItem>
            ))}
        </List>
      </Box>
    </Box>
  );
};

export default RadioButtonLabel;
